import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { DateTime } from 'luxon';
import { App } from '@capacitor/app';
import { userSelector } from '../../redux/user/selector';
import { useEvent } from '@mindly/ui-components';
import { updateUserMetadataAnalyticsParams } from 'src/api/user-metadata';

const BROWSER_AND_CLICK_ID_KEY = 'browserAndClickId';

export function useUpdateBrowserAndClickId() {
  const currentUser = useSelector(userSelector);

  const handleUpdateBrowserAndClickId = useEvent(async () => {
    try {
      if (!currentUser?.id) return;

      const previousTime = Number(window.localStorage.getItem(BROWSER_AND_CLICK_ID_KEY) ?? 0);
      if (previousTime && DateTime.utc().startOf('week').toSeconds() <= previousTime) return;

      const currentTime = DateTime.utc().toSeconds();
      window.localStorage.setItem(BROWSER_AND_CLICK_ID_KEY, `${currentTime}`);
      await updateUserMetadataAnalyticsParams();
    } catch (error) {
      console.error(error);
    }
  });

  useEffect(() => {
    App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) return;

      handleUpdateBrowserAndClickId();
    });

    handleUpdateBrowserAndClickId();
  }, [handleUpdateBrowserAndClickId]);
}
